import React from 'react';
import Overlay from '../Overlay';
import SimpleTable from '../tables/SimpleTable';
import FilterCard, { FIELD_TYPE, ReactSelect } from '../FilterCard';
import {
  getBoolSelectOptions,
  getBoolSelectOptionsWithInts,
  getBoolSelectVal,
  getNumPages,
  getPageOptions,
  hideModal,
  parseDate,
  showModalNoOutsideClick,
  slicePages,
} from '../../util/FormatUtil';
import { sweetalert } from '../../App';
import Select from 'react-select';
import { Result } from '../../types/Result';
import { ResultsManagementModal } from '../modals/ResultsManagementModal';
import NetworkUtil from '../../network/NetworkUtil';
import ResultsAPI from '../../network/ResultsAPI';
import { Column } from '../tables/TableBase';
import { Sorter, TableOrder } from '../../sorting/Sorter';
import PaginationTool from '../PaginationTool';
import SystemAPI from '../../network/SystemAPI';
import { AdminPages } from './AdminNav';
import { Kit } from '../../types/Kit';
import InventoryAPI from '../../network/InventoryAPI';
import { KitInventoryManagementModal } from '../modals/KitInventoryManagementModal';
import { KitInventoryCreationModal } from '../modals/KitInventoryCreationModal';
import AdminAPI from '../../network/AdminAPI';
import ServicesAPI from '../../network/ServicesAPI';
import { KitProductionModal } from '../modals/KitProductionModal';

const ITEMS_PER_PAGE = 25;

interface KitInventoryManagementState {
  showLoading: boolean;
  selectedKit: Kit;
  kitInventoryQueryResults;
  tableData: {}[];
  filter?: {
    SpecimenID;
    KitID;
    ServiceID;
    Registered
    ReturnLabelAssigned
  };
  direction?: TableOrder;
  page_options: ReactSelect[];
  selected_page?: { label; value };
  kitInventoryList: [];
  services: [];
  pageCustomQuestions?;
}

export class KitInventoryManagement extends React.Component<any, KitInventoryManagementState> {
  constructor(props) {
    super(props);

    this.state = {
      showLoading: false,
      selectedKit: {} as Kit,
      tableData: [] as any,
      kitInventoryQueryResults: [] as any,
      filter: {
        SpecimenID: null,
        KitID: null,
        ServiceID: null,
        Registered: 0,
        ReturnLabelAssigned: 0,
      },
      direction: 'asc',
      page_options: [{ label: '1', value: '1' }],
      selected_page: { label: '1', value: 1 },
      kitInventoryList: [],
      services: [],
      pageCustomQuestions: [],
    };

    this.createOrModifyKit = this.createOrModifyKit.bind(this);
  }

  componentDidMount() {
    document.title = 'Kit Management Page';
    this.loadKitInventoryData();
  }

  loadKitInventoryData() {
    this.setState({ showLoading: true }, async () => {
      InventoryAPI.getAllKitInventoryData().then((data) => {
        //@ts-ignore
        this.setState({ kitInventoryList: data,  });
      })
      ServicesAPI.getAllDTCServices().then((data) => {
        //@ts-ignore
        this.setState({ services: data.data,  });
      })
      this.queryKitInventoryData(1)
      this.setState({ showLoading: false });
    });
  }

  queryKitInventoryData(page: number) {
    this.setState({ showLoading: true }, async () => {
      let kitInventoryResponse = await InventoryAPI.filterKitInventory({
        filter: {
          SpecimenID: this.state.filter.SpecimenID,
          KitID: this.state.filter.KitID,
          Registered: this.state.filter.Registered,
          ServiceID: this.state.filter.ServiceID,
          ReturnLabelAssigned: this.state.filter.ReturnLabelAssigned,
        },
      });
      if (kitInventoryResponse.data.length < 1) {
        this.setState({ showLoading: false, tableData: [], kitInventoryQueryResults: null });
        return sweetalert.fire({ title: '', text: 'No Inventory returned', icon: 'info' });
      }
      if (!kitInventoryResponse.success) {
        this.setState({ showLoading: false });
        return sweetalert.fire({
          title: '',
          text: 'Unable to filter Inventory data at this time',
          icon: 'error',
        });
      }

      this.setState({
        tableData: slicePages(kitInventoryResponse.data, page, ITEMS_PER_PAGE),
        kitInventoryQueryResults: kitInventoryResponse.data,
        page_options: getPageOptions(getNumPages(kitInventoryResponse.data, ITEMS_PER_PAGE)),
        showLoading: false,
      });
    });
  }

  createInventory(filter) {
    this.setState({ showLoading: true }, async () => {
      try {
        let result = await InventoryAPI.createInventory(filter);

        if (result) {
          sweetalert.fire({ icon: 'success', title: '', text: 'Kit Inventory created and Excel file downloaded.' }).then(() => {
            this.setState({ showLoading: false });
            this.loadKitInventoryData(); 
            this.queryKitInventoryData(1);
          });
        } else {
          sweetalert.fire({ icon: 'error', title: '', text: 'Failed to generate and download inventory file.' });
          this.setState({ showLoading: false });
          this.loadKitInventoryData(); 
          this.queryKitInventoryData(1);
        }
      } catch (e) {
        console.error(e);
        this.setState({ showLoading: false });
        this.loadKitInventoryData(); 
        this.queryKitInventoryData(1);
      }
    });
  }

  createOrModifyKit(kit: Kit) {
    // console.log('kit in createOrModifyKit', kit)
    this.setState({ showLoading: true }, async () => {
      if (kit.ID === null) {
        try {
          let result = await InventoryAPI.createKit(kit);
          if (result.success) {
            sweetalert.fire({ icon: 'success', title: '', text: 'Kit Inventory Created' }).then(() => {
              this.setState(
                { showLoading: false,
                  selectedKit: {
                    SpecimenID: null,
                    KitID: null,
                    ServiceID: null,
                    ReturnShippingLabelNumber: "",
                    RegistrationDate: null,
                    OutboundShippingLabelNumber: "",
                    OrderNumber: "",
                  } as Kit,
                },
                () => {
                  this.loadKitInventoryData();
                  this.queryKitInventoryData(this.state.selected_page.value);
                }
              );
            });
          } else {
            sweetalert.fire({ icon: 'error', title: '', text: result.reason });
            this.setState({ showLoading: false });
          }
        } catch (e) {
          console.error(e);
          this.setState({ showLoading: false });
        }
      } else {
        try {
          let result = await InventoryAPI.editKit(kit);
          if (result.success) {
            sweetalert.fire({ icon: 'success', title: '', text: 'Kit Inventory Updated' }).then(() => {
              this.setState(
                { showLoading: false,
                  selectedKit: {
                    ID: "",
                    SpecimenID: null,
                    KitID: null,
                    ServiceID: null,
                    ReturnShippingLabelNumber: "",
                    RegistrationDate: null,
                    OutboundShippingLabelNumber: "",
                    OrderNumber: "",
                  } as Kit,
                },
                () => {
                  this.loadKitInventoryData();
                  this.queryKitInventoryData(this.state.selected_page.value);
                }
              );
            });
          } else {
            sweetalert.fire({ icon: 'error', title: '', text: result.reason });
            this.setState({ showLoading: false });
          }
        } catch (e) {
          console.error(e);
          this.setState({ showLoading: false });
        }
      }
      
    });
  }

  handleExportToCSV() {
    this.setState({ showLoading: true }, async () => {
      await NetworkUtil.downloadCSV('/api/admin/kitInventory/csv', 'Kit Management Data.xlsx', {
        filter: this.state.filter,
      });
    });
    this.setState({ showLoading: false });
  }

  changePage(page: number) {
    let allKitInventory = this.state.kitInventoryQueryResults;
    let returnData = slicePages(allKitInventory, page, ITEMS_PER_PAGE);
    this.setState({ tableData: returnData });
  }

  renderKitInventoryFilterFields() {
    return (
      <FilterCard
        fields={[
          {
            label: 'Specimen ID',
            key: 'SpecimenID',
            type: FIELD_TYPE.TEXT
          },
          {
            label: 'Kit ID',
            key: 'KitID',
            type: FIELD_TYPE.TEXT
          },
          {
            label: 'Service',
            key: 'ServiceID',
            type: FIELD_TYPE.SELECT,
            //@ts-ignore
            options: this.state.services.map(k => ({label: k.Name, value: k.ID})),
            isMapped: true,
            isMulti: true,
            textType: 'text',
            isFilter: true,
          },
          {
            label: 'Registered?',
            key: 'Registered',
            type: FIELD_TYPE.SELECT,
            options: getBoolSelectOptionsWithInts(),
            isMapped: true,
            textType: 'text',
            isFilter: true,
            isClearable: true
          },
          {
            label: 'Return Label Assigned?',
            key: 'ReturnLabelAssigned',
            type: FIELD_TYPE.SELECT,
            options: getBoolSelectOptionsWithInts(),
            isMapped: true,
            textType: 'text',
            isFilter: true,
            isClearable: true
          },
        ]}
        filterChanged={(e) => this.setState({ filter: e })}
      />
    );
  }

  useSorter(col: Column) {
    let sorter = new Sorter<any>();

    this.setState({
      tableData: sorter.sortByKey(this.state.tableData, col.key as keyof any, this.state.direction),
      direction: this.state.direction === 'asc' ? 'desc' : 'asc',
    });
  }

  render() {
    // console.log('KitInventoryManagement STATE', this.state)
    return (
      <React.Fragment>
        <PaginationTool />
        <Overlay show_loading={this.state.showLoading} />
        <KitInventoryManagementModal  
          key={this.state.selectedKit && this.state.selectedKit.ID ? this.state.selectedKit.ID : null}
          selectedKit={this.state.selectedKit}
          services={this.state.services}
          onSubmit={(kit) => {
            hideModal(KitInventoryManagementModal.ID);
            this.createOrModifyKit(kit);
          }}
        />
        <KitProductionModal
          kitInventory={this.state.kitInventoryList}
          onSubmit={(kit) => {
            hideModal(KitProductionModal.ID);
            this.createOrModifyKit(kit);
          }}
        />
        <KitInventoryCreationModal
          onSubmit={(filter) => {
            hideModal(KitInventoryCreationModal.ID);
            this.createInventory(filter);
          }}
        />

        <div className="container-fluid ">
          <div className={'row'}>
            <div className="col-12 col-md-12 col-lg-8 col-xl-5 pt-2">
              <main id="main-content" tabIndex={-1} aria-label="Kit Management">
                <div className="card mb-2">
                  <div className="card-header verlag-bold">
                    <h3>Kit Management</h3>
                  </div>
                  <div className="card-body">{this.renderKitInventoryFilterFields()}</div>
                  <div className="card-footer">
                    <button
                      className={'btn immySubmitButtonOutline'}
                      onClick={() => {
                        this.setState(
                          {
                            selected_page: { label: 1, value: 1 },
                          },
                          () => {
                            this.queryKitInventoryData(this.state.selected_page.value);
                          }
                        );
                      }}
                    >
                      Search
                    </button>
                    <button
                      className="btn btn-outline-success float-right"
                      onClick={() => {showModalNoOutsideClick(KitInventoryCreationModal.ID)}}>
                      Create Inventory
                    </button>
                    <button
                      className="btn btn-outline-success float-right mr-2"
                      onClick={() => {
                          showModalNoOutsideClick(KitProductionModal.ID);
                      }}>
                      Kit Production
                    </button>
                  </div>
                </div>
              </main>
            </div>
            {this.state.tableData && this.state.tableData.length > 0 && (
              <div className="col-12 col-md-12 col-lg-12 pt-2">
                <div className="card mt-2" style={{ marginBottom: '4rem' }}>
                  <div className="card-header verlag-bold stickToTop">
                    <h4 className="text-center text-md-left">
                      Kits
                      <section className="tableHeaderSection float-md-right d-flex justify-content-around">
                        <h4 className={'float-md-right'} aria-label="Total Records" role="alert">
                          Total: {this.state.kitInventoryQueryResults.length}
                        </h4>
                        <h4 className="d-inline-block float-right align-middle pr-2 ml-5">Page </h4>
                        <div className=" align-middle float-right pages ">
                          <Select
                            isSearchable={true}
                            placeholder={'1'}
                            noOptionsMessage={() => 'No option'}
                            value={this.state.selected_page}
                            aria-label="Table Page Number"
                            onChange={(e: ReactSelect) =>
                              this.setState({ selected_page: e }, () => this.changePage(e.value))
                            }
                            className={'state_select'}
                            options={this.state.page_options}
                          />
                        </div>
                      </section>
                      <button
                        className={'d-none d-md-inline btn btn-outline-primary ml-3'}
                        onClick={() => this.handleExportToCSV()}
                      >
                        Export to CSV
                      </button>
                    </h4>
                  </div>
                  <div className="card-body p-0 m-0 table-responsive">
                    <SimpleTable
                      columns={[
                        {
                          label: 'Kit ID',
                          key: 'KitID',
                          rawFormat: (val) => {
                            return (
                              <a
                                href={'#'}
                                className={'tableNameLinkColor'}
                                onClick={() => {
                                  this.setState({ selectedKit: val }, () =>
                                    showModalNoOutsideClick(KitInventoryManagementModal.ID)
                                  );
                                }}
                              >
                                {val.KitID}
                              </a>
                            );
                          },
                        },
                        {
                          label: 'Order Number',
                          key: 'OrderNumber',
                        },
                        {
                          label: 'Specimen ID',
                          key: 'SpecimenID',
                        },
                        {
                          label: 'Service',
                          key: 'ServiceID',
                          rawFormat: (val) => {
                            //@ts-ignore
                            const type = val.ServiceID && this.state.services?.length > 0 ? this.state.services.find(k => k.ID === val.ServiceID) : null;
                            return <p>{type ? type.Name : 'N/A'}</p>;
                          },
                        },
                        {
                          label: 'Registration Date',
                          key: 'RegistrationDate',
                          formatFunc: parseDate
                        },
                        
                        {
                          label: 'Outbound Label',
                          key: 'OutboundShippingLabelNumber',
                        },
                        
                        {
                          label: 'Return Label',
                          key: 'ReturnShippingLabelNumber',
                        },
                        {
                          label: 'Fulfillment Date',
                          key: 'FulfillmentDate',
                          formatFunc: parseDate
                        },
                      ]}
                      table_data={this.state.tableData}
                      columnClickedCallback={(col) => {
                        this.useSorter(col);
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}
